import { addDelimiters } from '@framework/data-helpers/convertTypes';

export const formatPositionSize = (value: string) => {
  if (!value) {
    return '';
  }

  const hasOnlyDigitsOrCommas = /^[0-9,]*$/;
  if (hasOnlyDigitsOrCommas.test(value)) {
    return addDelimiters(value);
  }

  return value;
};
